import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { useStyles } from './style'

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="confirm-dialog"
      maxWidth="lg"
      scroll="paper"
      classes={{ paper: classes.dialog }}
    >
      <DialogTitle id="confirm-dialog" className={classes.dialogTitle}>{title}</DialogTitle>
      <DialogContent dividers>
        <div className={classes.textMessage}>{children}</div>
      </DialogContent>
      <DialogActions>
        <ButtonSecondary
          onClick={() => onClose(false)}
          color="default"
          label={i18n.t('confirmationModal.buttons.cancel')}
        />
        <ButtonPrimary
          onClick={() => {
            onClose(false)
            onConfirm()
          }}
          label="Confirmar"
        />
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
